export const locale = {
    lang: 'en',
    data: {
      'WIZARD': {
        'TITULO' : 'Management files ',
        'DESCRIPCION': 'Upload your relevant files',
        'Carga':'Click here to upload',
        'Inicio': 'Home',
        'ERROR1':'Error',
        'ACC1':'Success',
        'COPY':'The key has been copy',
        'DATE':'Doctors date',
        'SEARCH':'Search',
        'OPC1':'People who need medical attention',
        'OPC2':'People who had severe traumatic event experience',
        'CARGANDO_FILTROS':'Loading information, please wait...',
        'MEDICOS':{
            'TITULO':'Doctors section'
        },
        'ALERT':{
            'BTN1':'Yes',
            'BTN2':'No',
            'LABEL01':'You have not added any doctor',
            'LABEL02':'You have not any date ',
            'LABEL03':'Are you sure you wanna do this actions',
        },
        'DatosColaboradores':{
            'Nombre': 'Collaborator name',
            'Correo': 'Email',
            'Tel': 'Telephone',
            'Area': 'Area',
            'NOFOUND':'The work center do not have collaborators who need help',
            'NOFOUNDDATA':'Aún no cuenta con los resultados de la encuesta'
        },
        'DATOSDOCTORES':{
            'NOMBRE':'Nombre completo',
            'CURP':'Curp',
            'CEDULA':'Cedula profesional',
            'ESPECIALIDAD':'Especialidad',
            'CT':'Work Center',
            'TELEFONO':'Telephone',
            'DOMICILIO':'Addres', 
            'EMAIL':'Email', 
            'ERROR':{
                'ERR01':'Field required',

            },
            'ACCIONES':{
                'LABEL01':'Add doctors',
                'LABEL02':'New doctos',
                'LABEL03':'Save',
                'LABEL04':'Close'
            },
            'PANEL':{
                'LABEL01':'Name',
                'LABEL02':'Email',
                'LABEL03':'Cedula',
                'LABEL04':'Especialidad',
                'LABEL05':'Work Center',
                'LABEL06':'Domicilio',
                'LABEL07':'Telefono',
                'LABEL08':'Clave',
                'LABEL09':'Delete',
                'LABEL10':'Actions',
                'LABEL11':'Copy key'
              }
            
        }
      
        
        }
    }
    
};
